import * as types from "../types";

const INITIAL_STATE = {
  hrmSettings: null,
};

const hrmSettingsReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.GET_HRM_SETTINGS:
    case types.UPDATE_HRM_SETTINGS:
      return { ...state, hrmSettings: action.payload };

    default:
      return state;
  }
};

export default hrmSettingsReducer;
